(function () {
  const GROUP = '.shopify_subscriptions_app_container .subscription_group';

  function selectGroup(group) {
    const radio = group.querySelector('input[type="radio"]');
    if (!radio) return;

    const container = group.closest('.shopify_subscriptions_app_container');
    if (container) {
      container.querySelectorAll('.subscription_group').forEach((item) => {
        item.classList.toggle('is-selected', item === group);
      });
    } else {
      group.classList.add('is-selected');
    }

    radio.disabled = false;
    radio.removeAttribute('disabled');
    if (radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncSelected(root) {
    (root || document).querySelectorAll(GROUP).forEach((group) => {
      group.classList.toggle('is-selected', Boolean(group.querySelector('input[type="radio"]:checked')));
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('a, button, select, .group_dropdown')) return;
      const group = event.target.closest(GROUP);
      if (!group) return;
      selectGroup(group);
    },
    true
  );

  document.addEventListener('change', function (event) {
    const radio = event.target;
    if (!radio.matches || !radio.matches('.shopify_subscriptions_app_container input[type="radio"]')) return;
    const group = radio.closest('.subscription_group');
    if (!group) return;
    if (radio.checked) {
      selectGroup(group);
    } else {
      group.classList.remove('is-selected');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncSelected();
    });
  } else {
    syncSelected();
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncSelected(event.target);
  });

  const WESTMORE_PLAN = /deliver every 2 weeks/i;
  let westmoreChoice = 'plan';
  let applyingWestmoreDefault = false;

  function westmorePage() {
    return document.body.classList.contains('product-westmore');
  }

  function visibleSubscriptionBlock() {
    return [...document.querySelectorAll('.shopify_subscriptions_app_block')].find((block) => {
      return !block.classList.contains('shopify_subscriptions_app_block--hidden');
    });
  }

  function applyWestmoreDefault() {
    if (applyingWestmoreDefault || !westmorePage() || westmoreChoice !== 'plan') return;
    const block = visibleSubscriptionBlock();
    if (!block) return;

    const radio = [...block.querySelectorAll('input[data-radio-type="selling_plan"]')].find((input) => {
      const label = input.closest('label');
      return label && WESTMORE_PLAN.test(label.textContent);
    });
    if (!radio) return;

    const planInput = document.querySelector('input[name="selling_plan"]');
    if (radio.checked && planInput && planInput.value === radio.dataset.sellingPlanId) return;

    applyingWestmoreDefault = true;
    const group = radio.closest('.subscription_group');
    if (!radio.checked && group) {
      selectGroup(group);
    } else {
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    applyingWestmoreDefault = false;
  }

  document.addEventListener(
    'change',
    function (event) {
      if (!westmorePage() || !event.isTrusted) return;
      const radio = event.target;
      if (!radio.matches || !radio.matches('.shopify_subscriptions_app_container input[data-radio-type]')) return;
      westmoreChoice = radio.dataset.radioType === 'one_time_purchase' ? 'one_time' : 'plan';
    },
    true
  );

  function watchWestmoreDefault() {
    if (!westmorePage()) return;
    applyWestmoreDefault();
    const root = document.querySelector('.shopify_subscriptions_app_container') || document.getElementById('MainContent');
    if (!root || root.dataset.volasPlanWatch === 'true') return;
    root.dataset.volasPlanWatch = 'true';
    const observer = new MutationObserver(function () {
      applyWestmoreDefault();
    });
    observer.observe(root, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchWestmoreDefault);
  } else {
    watchWestmoreDefault();
  }

  window.addEventListener('load', applyWestmoreDefault);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('.shopify_subscriptions_app_container')) {
      applyWestmoreDefault();
    }
  });
})();
